import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';

export default function CreateAdminUser() {
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState<{email: string, password: string} | null>(null);
  const { toast } = useToast();

  const createAdmin = async () => {
    console.log('Iniciando creación de usuario admin...');
    setLoading(true);
    const email = 'admin@globaltherapyhub.com';
    const password = 'Admin2025!GTH';

    try {
      console.log('Llamando a supabase.auth.signUp...');
      // Sign up the user with admin role in metadata
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            first_name: 'Admin',
            last_name: 'Global Therapy Hub',
            role: 'admin'
          }
        }
      });

      console.log('Respuesta de signUp:', { data, error });

      if (error) {
        console.error('Error en signUp:', error);
        throw error;
      }

      console.log('Usuario creado exitosamente');
      setCredentials({ email, password });
      toast({
        title: "Usuario Admin Creado",
        description: "El usuario admin ha sido creado exitosamente",
      });
    } catch (error: any) {
      console.error('Error capturado:', error);
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle>Crear Usuario Administrador</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Haz clic en el botón para crear el usuario administrador del sistema.
          </p>
          
          <Button 
            onClick={createAdmin} 
            disabled={loading || !!credentials}
            className="w-full"
          >
            {loading ? 'Creando...' : 'Crear Usuario Admin'}
          </Button>

          {credentials && (
            <div className="mt-4 p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
              <h3 className="font-semibold mb-2 text-green-900 dark:text-green-100">✅ Credenciales del Admin:</h3>
              <p className="text-sm text-green-800 dark:text-green-200"><strong>Email:</strong> {credentials.email}</p>
              <p className="text-sm text-green-800 dark:text-green-200"><strong>Password:</strong> {credentials.password}</p>
              <p className="text-xs text-green-700 dark:text-green-300 mt-2">
                Guarda estas credenciales en un lugar seguro.
              </p>
            </div>
          )}

          {credentials && (
            <Button 
              onClick={() => window.location.href = '/admin/login'}
              className="w-full mt-4"
            >
              Ir a Login Admin
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
